export default __webpack_public_path__ + "27f8757651b16db32544485436154e7a.jpg";